import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '@/features/Profile/SettingsLayout';

export const Route = createFileRoute('/trainer/settings')({
  component: SettingsLayout,
});
